import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const ThemeContext = createContext(null);

export const CHART_THEME = {
  dark: {
    tick: "#8E8E99",
    tickStrong: "#D4D4D8",
    grid: "rgba(255,255,255,0.06)",
    cursor: "rgba(255,255,255,0.04)",
    tooltip: { borderRadius: 10, border: "1px solid rgba(255,255,255,0.12)", fontSize: 13, background: "rgba(15,15,17,0.92)", color: "#FAFAFA" },
  },
  light: {
    tick: "#71717A",
    tickStrong: "#3F3F46",
    grid: "#E9E9EC",
    cursor: "rgba(0,0,0,0.04)",
    tooltip: { borderRadius: 10, border: "1px solid #E4E4E7", fontSize: 13, background: "rgba(255,255,255,0.96)", color: "#18181B" },
  },
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("ssvp_theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("ssvp_theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);

  const value = useMemo(() => ({ theme, toggleTheme, chart: CHART_THEME[theme] }), [theme, toggleTheme]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
